import { Injectable } from '@angular/core';

import * as pdfMakeIm from 'pdfmake/build/pdfmake.js';
import * as pdfFontsIm from 'pdfmake/build/vfs_fonts.js';


@Injectable()
export class AllDivisionsExportPDFService {

    exportPDF(fileName: string, searchFields: string[], divisionSubdivisionMap: Map<string, Map<string, any[]>>, columns: any[], titleName: string, notes:string[]) {
        const pdfMake = pdfMakeIm;
        const pdfFonts = pdfFontsIm;

        // Safe VFS assignment - check if pdfFonts.pdfMake exists
        if (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs) {
            pdfMake.vfs = pdfFonts.pdfMake.vfs;
        } else if (pdfFonts && pdfFonts.vfs) {
            // Alternative VFS path for different pdfmake versions
            pdfMake.vfs = pdfFonts.vfs;
        }
        
        const docDefinition = this.getDocDefinition(searchFields, divisionSubdivisionMap, columns, titleName, notes);
        pdfMake
          .createPdf(docDefinition)
          .download(fileName+'.pdf');
   }

   getDocDefinition(searchFields: string[], divisionSubdivisionMap: Map<string, Map<string, any[]>>, columns: any[], titleName: string,notes:string[]){
    
      let content = [];
      let todayDate = new Date()
      content.push(
        this.buildDocHeaderSection(titleName, todayDate)
      )
      content.push(
        this.buildPdfNotesSection(notes)
      )

 
      for (let i = 0; i < searchFields.length; i++) {
        content.push({ text: searchFields[i], style: 'header', margin: [20, 0], bold: true });
      } 
  
     

     this.buildPdfDivisionSection(divisionSubdivisionMap, content, columns);
     
       return {
          pageMargins: [35, 50, 0, 20],
          pageOrientation: 'portrait',
          content: content
        };
      }

  buildPdfDivisionSection(divisionSubdivisionMap: Map<string, Map<string, any[]>>, content: any[], columns: any[]) {
    var isFirst = true;

    divisionSubdivisionMap.forEach((value, div) => {

     
      if (!isFirst) {
        content.push(
          { text: '', pageBreak: 'before' }
        );
        content.push(
          {
            style: 'pdfTable',
            margin: [0,0, 55, 5],
            table: {
              widths: ['*'],
              body: [
                [{ text: div, style: 'subheader', fontSize: 14, bold: true, fillColor: '#D8D8D8', alignment: 'center' }

                ]
              ]
            }
          }
        );
      } else {
        isFirst = false;
        content.push(
          {
            style: 'pdfTable',
            margin: [0, 20, 30, 10],
            table: {
              widths: ['*'],
              body: [
                [{ text: div, style: 'subheader', fontSize: 14, bold: true, fillColor: '#D8D8D8', alignment: 'center' }

                ]
              ]
            }
          }
        );
      }
      value.forEach((value1, subdiv) => {

        content.push({ text: subdiv, style: 'subheader', margin: [0, 5, 0, 0], fontSize: 10, italics: true, bold: true, alignment: 'left' });


        content.push({
          style: 'pdfTable',
          layout: { dontBreakRows: true },
          margin: [0, 0, 30, 10],
          table: {
            widths: [40, 40, 30, 35, 35, 35, 35, 35, 35, 35, 35, 35],
            body: this.buildTableBody(value1, columns)
          }
        });

      });
    });
  }

   buildPdfNotesSection(notes: string[]): any {
    return {
      style: 'pdfTable',
      margin: [0, 20, 30, 10],
      table: {
        body: this.buildNotes(notes)
      },
      layout: {
        defaultBorder: false
      }
    };
  }

   buildDocHeaderSection(titleName: string, todayDate: Date): any {
    return {
      style: 'pdfTable',
      margin: [0, 5, 20, 5],
      table: {
        widths: ['*'],
        body: [
          [
            { text: titleName, style: 'header', fontSize: 16, fillColor: '#4682B4', alignment: 'center', border: [true, true, true, false] }
          ],
          [
            { text: 'Report Created on: ' + todayDate.toISOString().split('T')[0], fillColor: '#4682B4', style: 'header', fontSize: 9, alignment: 'center', border: [true, false, true, true] }
          ]
        ]
      },
      layout: {
        hLineWidth: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? 2 : 1;
        },
        vLineWidth: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? 2 : 1;
        },
        hLineColor: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? 'black' : 'gray';
        },
        vLineColor: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
        },
      }
    };
  }

   

    buildTableBody(data, columns) {
         const body = [];
         const colsField = columns.map(col => {
           return col.field;
         });
         const colsLabel = columns.map(col => {
           return { text: col.header,    bold: true, fontSize: 8, alignment: 'center' };
         });
         body.push(colsLabel);

         let prevUnit = null;
         data.forEach(function (row) {
           const dataRow = [];
           if (prevUnit !== null && prevUnit !== row.unit) {
             body.push(columns.map(col => {
               return { text: ' ', fillColor: '#C0C0C0', fontSize: 8, alignment: 'center' };
             }));
           }
           colsField.forEach(function (column) {
             dataRow.push(
               { text: (row[column] ? row[column].toString() : ''), fontSize: 8,  bold: false, alignment: 'center' });
           });
           prevUnit = row.unit;
           body.push(dataRow);
         }); 
        
         return body;
       }

        getCSXTableLayoutWithNoBackground() {
        return {         
          hLineColor(i, node) {
            return i === 1 ? '#2f6bbd' : '#c0c2c7';
          },
          vLineWidth(i, node) {
            return 0;
          },
          hLineWidth(i, node) {
            return i === 0 ? 0 : 1;
          },
          paddingTop(i, node) {
            return 5;
          },
          paddingBottom(i, node) {
            return 5;
          },
          
        };
      }

      buildNotes(notes:string[]) : any[]{
       
       let notesText = [];
        notes.forEach(function(note)  {
          notesText.push([{ text: note, border: [false, false, false, false], fontSize: 9,	preserveLeadingSpaces: true }]);
        });
        
        console.log(notesText)
        return notesText;
      }
      
}
